export default __webpack_public_path__ + "24a83972cd6196930c89a262e7f2edba.webp";